import api from './api';

const resource = 'SquareCatalog/';

export const importMenu = async (body) => {
  return await api.post(resource + 'Import', body);
};

export const importStatus = async (jobId) => {
  return await api.get(
    resource + 'ImportStatus?jobid=' + encodeURIComponent(jobId)
  );
};

export const sync = async (body) => {
  return await api.post(resource + 'Sync', body);
};

export const syncStatus = async (companyId) => {
  return await api.get(
    resource + 'SyncStatus?companyid=' + encodeURIComponent(companyId)
  );
};

export const priceMismatches = async (companyId) => {
  return await api.get(
    resource + 'PriceMismatches?companyid=' + encodeURIComponent(companyId)
  );
};

export const modifierMappingReview = async (companyId) => {
  return await api.get(
    resource + 'ModifierMappingReview?companyid=' + encodeURIComponent(companyId)
  );
};

export const pullInventory = async (body) => {
  return await api.post(resource + 'PullInventory', body);
};

export const objects = async (companyId, type) => {
  return await api.get(
    resource +
      'Objects?companyid=' +
      encodeURIComponent(companyId) +
      (type ? '&type=' + type : '')
  );
};

export const needsReview = async (companyId) => {
  return await api.get(
    resource + 'NeedsReview?companyid=' + encodeURIComponent(companyId)
  );
};

export const needsReviewResolve = async (body) => {
  return await api.post(resource + 'NeedsReviewResolve', body);
};

export const syncHistory = async (companyId) => {
  return await api.get(
    resource + 'SyncHistory?companyid=' + encodeURIComponent(companyId)
  );
};

export const priceMismatchResolve = async (body) => {
  return await api.post(resource + 'PriceMismatchResolve', body);
};

export const modifierGroupImport = async (body) => {
  return await api.post(resource + 'ModifierGroupImport', body);
};

const squareCatalogApi = { importMenu, importStatus, sync, syncStatus, priceMismatches, modifierMappingReview, pullInventory, objects, needsReview, needsReviewResolve, syncHistory, priceMismatchResolve, modifierGroupImport };

export default squareCatalogApi;
